import { HttpForm } from "./HttpForm";
import { Product } from "../Product/Product";
import Fuse from "fuse.js";
export class ProductSelection extends HttpForm {
    display = false;
    account;
    currency;
    criteria = '';
    options = {
        shouldSort: true,
        includeScore: true,
        threshold: 0.4,
        keys: ['name']
    };
    filteredProducts = false;
    availableProducts = false;
    selectedProducts = [];
    product = new Product();
    constructor(account, currency = false) {
        super();
        this.setLoadingState(false);
        this.account = account;
        this.currency = currency;
    }
    mount() {
        return Promise.all([
            this.loadProducts()
        ]).then(() => {
            this.setLoadingState(true);
        });
    }
    loadProducts() {
        let params = {
            account: this.account,
            currency: this.currency,
            active: true,
        };
        return this.product.search(params).then((response) => {
            this.filteredProducts = this.availableProducts = response.data.data;
        });
    }
    filterResults() {
        let self = this;
        if (!self.criteria || self.criteria === '') {
            return self.filteredProducts = self.availableProducts;
        }
        if (self.availableProducts) {
            let fuse = new Fuse(self.availableProducts, self.options);
            return self.filteredProducts = fuse.search(self.criteria).map(r => r.item);
        }
    }
    toggleProductSelection(product) {
        if (this.isProductSelected(product.sku)) {
            this.selectedProducts = this.selectedProducts.filter(function (sku) {
                return sku !== product.sku;
            });
        }
        else {
            this.selectedProducts.push(product.sku);
        }
    }
    isProductSelected(sku) {
        return this.selectedProducts.includes(sku);
    }
    toggleModal() {
        this.display = !this.display;
    }
    cancelAction() {
        this.display = false;
    }
    confirmAction() {
        this.display = false;
    }
}
